module.exports = __webpack_public_path__ + "img/cookie-illustration.c29faefe.png";